import {combineReducers} from "redux";
import { call, put, select, takeLatest } from 'redux-saga/effects';
import {reportsAPI} from "../../../api/reports";
import { createActions } from "../../factory/actionFactory";
import {START} from "../../../constants/action-postfix";
import { loaderReducer } from "./loader/loaderReducer";
import { formReducer } from "./form/formReducer";
import { dataReducer } from "./data/dataReducer";
import { reportParamsReducer } from "./report_params/reportParamsReducer";
import { getModifiedData } from "../../../utils/gia";



export const GIA_REQUEST = "GIA_REQUEST";
export const SET_FORM_DATA = "SET_GIA_FORM_DATA";
export const SET_GIA_REPORT_PARAMS = "SET_GIA_REPORT_PARAMS";

export const giaReducer = combineReducers({
    form: formReducer,
    data: dataReducer,
    loader: loaderReducer,
    report_params: reportParamsReducer,
});

//actions
export const giaActions = createActions('gia', GIA_REQUEST);
export const setFormData = payload => ({ type: SET_FORM_DATA, payload});
export const setReportParams = payload => ({ type: SET_GIA_REPORT_PARAMS, payload});

// SAGAS
export function* giaWatcher() {
    yield takeLatest(`${GIA_REQUEST}${START}`, giaWorker)
}

function* giaWorker() {
    try {
        const auth = yield select(state => state.auth.data)
        const form = yield select(state => state.reports.gia.form)
        const params = {...auth, ...form}
        const response = yield call(reportsAPI.gia, params);
        const payload = getModifiedData(response.data.Answer.Data_);
        yield put(giaActions.giaRequestSuccess(payload));
        yield put(setReportParams(form));
    } catch(error) {
        yield put(giaActions.giaRequestError(error));
    }
}
